(function () {
    'use strict';

    angular
        .module('franchisee-portal.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, PATHS) {
        $stateProvider
            .state('app-auth', {
                abstract: true,
                onEnter: $rootScope => {
                    $rootScope.isOauth = true;
                    $rootScope.hideLoading = true;
                }
            })

            .state('app-auth.oauthcallback', {
                title: 'Autenticação',
                url: '/oauthcallback',
                templateUrl: `${PATHS.PHYSICAL}/components/oauthcallback/oauthcallback.html`,
                controller: 'OauthCallbackController',
                controllerAs: 'vm'
            })
    }
}());